<template>
    <div class="er-items-step">
        <div class="er-items-step-title">{{$store.getters.t('expenditure_request_items_step_title')}}</div>
        <!--        <btn-group :buttons="tabs" :value="currentTab" @change="currentTab = $event"></btn-group>-->
        <div class="actions">
            <div class="action action-search">
                <input v-model="keyword" @keyup="getItems(1)" type="text" :placeholder="$store.getters.t('expenditure_request_items_step_search_placeholder')">
            </div>
            <div class="action action-total">
                <div class="actions-total-text" v-if="pagination">{{$store.getters.t('expenditure_request_items_step_total_prefix')}} {{pagination.total}} {{$store.getters.t(itemsType === 'contractors' ? 'expenditure_request_items_step_total_contractors' : 'expenditure_request_items_step_total_goods')}}</div>
            </div>
        </div>
        <div class="contractors" v-if="items">
            <div class="contractor er-card er-card-sm"
                 :class="{selected: expenditureRequest.contractor_id === contractor.id}"
                 v-for="contractor in items"
                 @click="updateExpenditureRequest({key: 'contractor_id', data: contractor.id})"
            >
                <div class="contractor-logo">
                    <img v-if="contractor.main_image" :src="'/storage' + contractor.main_image.path" alt="">
                    <div class="contractor-logo-default" v-else></div>
                </div>
                <div class="contractor-info">
                    <div class="contractor-info-address">
                        <img src="/assets/images/svg/mapPoint.svg" alt="">
                        <span>{{$store.getters.t('expenditure_request_items_step_country_belarus')}}</span>
                    </div>
                    <div class="contractor-info-name">{{contractor.name}}</div>
                    <div class="contractor-info-desc">{{contractor.description}}</div>
                </div>
            </div>
        </div>
        <div class="pagination-area" v-if="pagination">
            <nav class="navigation pagination" role="navigation">
                <div class="nav-links">
                    <paginate
                        v-model="pagination.current_page"
                        :page-count="pagination.last_page"
                        :click-handler="paginateClickCallback"
                        :prev-text="''"
                        :next-text="''"
                        :container-class="'className'"
                        :page-class="'page-numbers'"
                        :page-link-class="''"
                        :active-class="'current'"
                        :prev-class="'prev page-numbers'"
                        :prev-link-class="'lnr lnr-arrow-left'"
                        :next-class="'next page-numbers'"
                        :next-link-class="'lnr lnr-arrow-right'"
                    >
                    </paginate>
                </div>
            </nav>
        </div>

    </div>
</template>

<script>
import BtnGroup from "./chunks/BtnGroup";
import {paginationScrollTo} from "../helpers/helpers";

import {mapGetters, mapMutations} from "vuex";

export default {
    name: "ExpenditureRequestItemsStep",
    components: {BtnGroup},
    props: {
        itemsType: {
            type: String,
            default: 'contractors'
        }
    },
    data() {
        return {
            keyword: '',
            currentTab: 'contractors',
            tabs: [
                {
                    title: this.$store.getters.t('expenditure_request_items_tabs_contractors'),
                    value: 'contractors',
                },
                {
                    title: this.$store.getters.t('expenditure_request_items_tabs_goods'),
                    value: 'goods',
                },
                {
                    title: this.$store.getters.t('expenditure_request_items_tabs_other'),
                    value: 'other',
                },
            ],
            items: null,
            pagination: null
        }
    },
    computed: {
        ...mapGetters({
            expenditureRequest: 'getterExpenditureRequest'
        })
    },
    mounted() {
        this.getItems();
    },
    methods: {
        ...mapMutations({
            updateExpenditureRequest: 'setterExpenditureRequestParam'
        }),
        getItems(page) {
            let sectorsIds = [], url;

            switch (sectorsIds) {
                case 'goods':
                    sectorsIds.push(1);
                    url = '/api/'; // Тут урл товаров, когда будут
                    break;
                default:
                    sectorsIds.push(2);
                    url = '/api/contractors';
            }

            let params = {
                page: page,
                sectors_ids: sectorsIds
            };

            if (this.keyword) {
                params.keyword = this.keyword;
            }

            axios.get(url, {params}).then(response => {
                this.items = response.data.data;
                this.pagination = response.data.meta;
            })
        },
        paginateClickCallback(page) {
            paginationScrollTo('.er-items-step')

            this.getItems(page);
        },
    },
    watch: {
        keyword (){
            this.updateExpenditureRequest({key: 'contractor_id', data: null})
        }
    }
}
</script>

<style lang="scss" scoped>
.er-items-step {
    &-title {
        font-weight: 700;
        font-size: 24px;
        line-height: 34px;
        text-align: center;
        margin-bottom: 50px;
    }

    .actions {
        display: flex;
        margin-top: 50px;
        flex-wrap: wrap;

        .action {
            width: 50%;

            @media (max-width: 991px) {
                width: 100%;
            }

            &-total {
                display: flex;
                align-items: center;
                justify-content: flex-end;

                @media (max-width: 991px) {
                    margin-top: 5px;
                    text-align: center;
                }

                &-text {
                    font-size: 14px;
                }
            }
        }
    }

    .contractors {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 30px;

        .contractor {
            width: calc(50% - 15px);
            margin-bottom: 30px;
            display: flex;
            cursor: pointer;

            @media (max-width: 991px) {
                width: 100%;
            }

            &-logo {
                width: 80px;
                min-width: 80px;
                max-width: 80px;

                img {
                    width: 100%;
                }

                &-default {
                    height: 80px;
                    background-color: #ccc;
                    border-radius: 5px;

                }
            }

            &-info {
                margin-left: 20px;
                &-address {
                    display: flex;
                    color: #929292;
                    font-size: 10px;

                    img {
                        margin-right: 5px;
                    }
                }

                &-name {
                    margin-top: 5px;
                }

                &-desc {
                    font-size: 11px;
                    color: #555555;
                    margin-top: 5px;
                }
            }
        }
    }
}
</style>
